<script setup lang="ts">
/* Local-dev only: live up/down status of the agent workers and NURO, so a
   developer can tell a dead backend from a bug. Rendered by the layout behind
   `import.meta.dev`; the endpoint it polls is a 404 outside dev. */
import { STALE_TIME } from '@rialtic/utils'

defineProps<{ collapsed?: boolean }>()

const { data: services, refetch } = useQuery({
  key: ['dev', 'service-status'],
  query: () =>
    $fetch<{ name: string; up: boolean; detail: string }[]>(
      '/api/dev/service-status',
    ),
  enabled: import.meta.client,
  staleTime: STALE_TIME.FIVE_SECONDS,
  persist: false,
})

const visibility = useDocumentVisibility()
const { pause, resume } = useIntervalFn(refetch, STALE_TIME.FIVE_SECONDS, {
  immediate: false,
})
watch(visibility, (state) => (state === 'visible' ? resume() : pause()), {
  immediate: true,
})
</script>

<template>
  <div
    class="border-default flex flex-col gap-1 border-b px-2 py-2 text-xs"
    data-testid="dev-service-status"
  >
    <span v-if="!collapsed" class="text-muted px-1 font-medium uppercase">
      Dev services
    </span>
    <UTooltip
      v-for="service in services ?? []"
      :key="service.name"
      :content="{ side: 'right' }"
      :text="`${service.name}: ${service.detail}`"
    >
      <div
        class="flex items-center gap-2 px-1"
        :class="{ 'justify-center': collapsed }"
      >
        <span
          class="size-2 shrink-0 rounded-full"
          :class="service.up ? 'bg-success' : 'bg-error'"
        />
        <span v-if="!collapsed" class="truncate">{{ service.name }}</span>
        <span v-if="!collapsed" class="text-muted ml-auto">
          {{ service.up ? 'up' : 'down' }}
        </span>
      </div>
    </UTooltip>
  </div>
</template>
